import { render, staticRenderFns } from "./CategoryDropdown.vue?vue&type=template&id=73876d99&scoped=true&"
import script from "./CategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./CategoryDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDropdown.vue?vue&type=style&index=0&id=73876d99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73876d99",
  null
  
)

export default component.exports